import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "registration",
  "serial",
  "model",
  "manufacturer",
  "landings",
  "hours",
  "as_of",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  registration: "Registration",
  serial: "Serial no.",
  model: "Model",
  manufacturer: "Manufacturer",
  landings: "Landings",
  hours: "Flight hours",
  as_of: "Hours as of",
  updated: "Updated",
}

export const COLUMN_SIZING: ColumnSizing<Column> = {
  id: "aircraft",
  widths: {
    registration: 7.5,
    serial: 7,
    model: 8,
    manufacturer: 8,
    landings: 6,
    hours: 7,
    as_of: 7,
    updated: 8.5,
  },
  fill: "model",
  extras: [],
  dropOrder: ["updated", "serial", "manufacturer", "as_of"],
}

export function withRegistration(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "registration" || columns.includes(column),
  )
}
